import React, { useState } from 'react';
import apps from '/src/pages/HomePage/Leads/assets/apps.svg';
import down from '/src/assets/down.svg';
import ComingSoon from '../../../../components/common/ComingSoon';

interface LeadsDropdownProps {
  onClick: () => void;
  totalLeads: number;
}

const LeadsDropdown: React.FC<LeadsDropdownProps> = ({ onClick, totalLeads }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [showComingSoon, setShowComingSoon] = useState(false);

  const toggleDropdown = () => {
    setShowComingSoon(true);
  };

  return (
    <div className="relative">
      <button
        onClick={toggleDropdown}
        className="flex items-center gap-2 px-[10px] h-[28px] py-1 text-[#222222] bg-[#FFFFFF] rounded-[10px] hover:bg-[#FAFAFA] shadow-[0px_0px_2px_0px_#E0E0E0]"
      >
        <img src={apps} alt="apps" className="w-5 h-5" />
        <span className="text-sm font-normal ">All companies</span>
        <img src={down} alt="down" className="w-[14px] h-[14px]" />
      </button>

      <ComingSoon 
        isOpen={showComingSoon}
        onClose={() => setShowComingSoon(false)}
      />
    </div>
  );
};

export default LeadsDropdown;
